export default __webpack_public_path__ + "static/media/cam.432d74d2.jpg";